// import 'svgxuse'; // Uncomment to support svg icons on IE

import { createPopper } from '@popperjs/core';
import * as bootstrap from 'bootstrap';
import ClipboardJS from 'clipboard';
import './components/header'
import './components/observer'
import './components/offcanvas'
import './components/loadmore'
import './components/numbers'
import './components/article'
import './components/panel'
import './components/modal'
import './components/carousel'
import './components/countdown'
import './components/smooth-scroll'
import './components/roi-calculator'
import './components/gravity-forms'
import './components/promo-banner'
import './components/menu'
import './components/cbid'

// BS Tooltip init
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

// BS Scrollspy init
const scrollSpy = new bootstrap.ScrollSpy(document.body, {
  target: '#js-scrollspy',
  rootMargin: '0px 0px -75% 0px',
});

if (typeof right_works_settings !== 'undefined' ) {
  if (parseInt(right_works_settings?.is_application_directory_page) > 0) {
    jQuery(document).on("sf:ajaxstart", ".searchandfilter", function(){
      jQuery(".js-update-count").css('opacity', .5);
    });

    jQuery(document).on("sf:ajaxfinish", ".searchandfilter", function(){

      // get _sft_rw_application_category and _sf_s from the URL
      var url = new URL(window.location.href);
      var _sft_rw_application_category = url.searchParams.get("_sft_rw_application_category");
      var _sf_s = url.searchParams.get("_sf_s");

      // Build the API URL
      var count_url = "/wp-json/convertiv/v1/post-count/rw_applications";

      var params = {};
      if (_sft_rw_application_category) {
        params.taxonomy = "rw_application_category";
        params.term_slug = _sft_rw_application_category;
      }

      if (_sf_s) {
        params.search = _sf_s;
      }

      // Convert parameters object to query string
      var query_string = new URLSearchParams(params).toString();
      if (query_string) {
        count_url += "?" + query_string;
      }

      jQuery(".js-update-count").css('opacity', .5);

      // Get the number of rw_applications via AJAX call to the REST API
      jQuery.ajax({
        url: count_url,
        type: "GET",
        success: function(data) {
          if (data?.count) {
            jQuery(".js-update-count").html('Showing ' + data?.count + ' applications');
            jQuery(".js-update-count").css('opacity', 1);
          } else {
            jQuery(".js-update-count").html('Showing 0 applications');
            jQuery(".js-update-count").css('opacity', 1);
          }
        },
        error: function(error) {
          console.log(error);
        }
      });
    });
  }
}


new ClipboardJS('[data-clipboard-text]');

// function toggleAlertClass() {
//   const alertBars = document.querySelectorAll('.js-alert');
//   if (alertBars.length > 0) {
//     if (window.innerWidth < 576) {
//       alertBars.forEach(alertBar => alertBar.classList.add('alert-horizontal'));
//     } else {
//       alertBars.forEach(alertBar => alertBar.classList.remove('alert-horizontal'));
//     }
//   }
// }

// // Initial call on page load
// window.addEventListener('load', toggleAlertClass);

// // Call on window resize
// window.addEventListener('resize', toggleAlertClass);



function stickyForms() {
  var formElement = document.querySelector('.js-lander-form');
  var formElementContent = formElement?.querySelector('.callout');
  
  if (!formElement) {
    return;
  }

  var screenWidth = window.innerWidth;
  var formHeight = formElementContent.offsetHeight;
  var viewportHeight = window.innerHeight;

  formElement.removeAttribute('style');

  if (screenWidth > 1024 && formHeight < (viewportHeight - 250)) {
    var rect = formElement.getBoundingClientRect();

    // Calculate top and left position relative to the document
    var scrollTop = document.documentElement.scrollTop;
    var scrollLeft = document.documentElement.scrollLeft;
    var topPosition = (rect.top + scrollTop) - 20;
    var leftPosition = rect.left + scrollLeft;

    // Apply fixed positioning with the calculated top and left values
    formElement.style.position = 'fixed';
    formElement.style.top = topPosition + 'px';
    formElement.style.left = leftPosition + 'px';
    formElement.style.width = rect.width + 'px';
  } else {
    formElement.removeAttribute('style');
  }
}

window.addEventListener('load', stickyForms);
window.addEventListener('resize', stickyForms);